import { useApolloClient } from "@apollo/client";
import { Typography, Box, Container, Card } from "@mui/material";
import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { getCandidateByID } from "../../../../graphql/query";
import { globalLoadingAtom } from "../../../../shared/globalStates";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";

const Mostest1 = () => {
  const { id } = useParams();
  const client = useApolloClient();
  const history = useHistory();
  const [loading, setLoading] = useRecoilState(globalLoadingAtom);
  useEffect(() => {
    setLoading(true);
    getCandidateByID(client).then((result) => {
      setLoading(false);
      if (!!result.cfit_score) history.push("/404");
    });
  }, []);

  return loading ? (
    <></>
  ) : (
    <Box width="auto" justifyContent="center">
      <Container maxWidth="md">
        <Box>
          <Typography
            my={1}
            fontSize={36}
            textTransform="uppercase"
            sx={{ fontWeight: "400 !important" }}>
            MOSTEST 1
          </Typography>
        </Box>
        <Card>
          {+id === 1 ? (
            <Section1 />
          ) : +id === 2 ? (
            <Section2 />
          ) : +id === 3 ? (
            <Section3 />
          ) : (
            +id === 4 && <Section4 />
          )}
        </Card>
      </Container>
    </Box>
  );
};

export default Mostest1;
